import { dasModal } from "../modal_v2.js";
import { identityService } from "./identityService_v2.js";
import { colors } from "../colors_v2.js";
import { profile } from "./profile_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { iPop } from "../ipop_v2.js";
import {
  currentPasswordSplainerHTML,
  renderCurrentPasswordSplainer,
} from "./accountDetailsUI_v2.js";

const render = async () => {
  const html = `
    <div class="popUpHead">Delete Account</div>
    <p>Are you sure you want to delete your account?</p>
    <div>There is no undo for this.<div id="deleteSplainer" class="i">ⓘ</div></div>
    <p>Enter <span class="noWrap">"permanently delete"</span> to proceed:</p>
    <div id="deleteAccountform">
      <div class="center">
        <label for="deleteAccountInput">Confirm:</label>
        <input 
          class="bottom7" 
          type="text" 
          id="deleteAccountInput" 
          placeholder="permanently delete" 
          autocomplete="off"></input>
        <div class="inputMessages center" id="deleteAccountlMessage"></div>
      </div>
      <div class="center">
        <label for="deletePasswordInput">Current Password:${currentPasswordSplainerHTML("deletePasswordSplainer")}</label>
        <input
          class="bottom7"
          type="password"
          id="deletePasswordInput"
          autocomplete="current-password"></input>
      </div>
      <div class="center">
        <button 
          type="submit" 
          id="deleteButton" 
          class="submitButton bottom7 button workADayButtons" disabled>
          Submit
        </button>
        <div class="inputMessages" id="deleteMsg"></div>
      </div>
    </div>
  `;

  dasModal.render(html);
  document.getElementById("deletePasswordInput").style.backgroundColor =
    colors.getGameColor("lighterAccent");
};

const renderDeleteSplainer = (event) => {
  iPop.render({
    text: "Does not affect other people's match history.",
    event,
  });
};

const handleDelete = async (event) => {
  const deleteButton = document.getElementById("deleteButton");
  const deleteMsg = document.getElementById("deleteMsg");
  const currentPassword = document.getElementById("deletePasswordInput").value;
  if (currentPassword.length === 0) {
    deleteMsg.innerText = "Please enter your current password";
    return;
  }
  deleteButton.disabled = true;
  document.body.style.cursor = "wait";
  deleteButton.style.cursor = "wait";
  deleteMsg.innerText = "Submiting...";
  const result = await identityService.deleteIdentity(currentPassword);
  document.body.style.cursor = "default";
  deleteButton.style.cursor = "default";
  deleteButton.disabled = false;
  deleteMsg.innerText = "";
  if (result.status !== 200) {
    deleteMsg.innerText =
      result.message || result.error || "Error: Unable to delete the account";
    return;
  }
  if (result.status === 200) {
    dasModal.close();
    dasModal.render(
      `<div class="max">The account has been deleted. You are now playing as a temporary identity.</div>`,
    );
    profile.render("small");
    // There is always an identity:
    const newPlayerOne = await identityService.createIdentity({
      name: "Player One",
      type: "temp",
    });
    identityService.setPlayingAs({
      name: newPlayerOne.identity.name,
      createMatch: false,
    });
    colors.setScheme("muted");
  }
};

const handleKeyUp = (event) => {
  const text = event.target.value;
  const deleteButton = document.getElementById("deleteButton");
  if (text === "permanently delete") {
    deleteButton.disabled = false;
  } else {
    deleteButton.disabled = true;
  }
};

eventHub.registerEvent("keyup", "deleteAccountInput", handleKeyUp);
eventHub.registerEvent("click", "deleteButton", handleDelete);
eventHub.registerEvent("click", "deleteSplainer", renderDeleteSplainer);
eventHub.registerEvent(
  "click",
  "deletePasswordSplainer",
  renderCurrentPasswordSplainer,
);

export const deleteAccount = {
  render,
};
